import { FE_BATCH_9_SIGN_UP_MODAL_SUBTEXT_250417 } from "@faire/retailer-settings/FE_BATCH_9_SIGN_UP_MODAL_SUBTEXT_250417";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingBatch9SignUpModalSubtext = () =>
  useSetting(FE_BATCH_9_SIGN_UP_MODAL_SUBTEXT_250417);

export const useAssignSettingBatch9SignUpModalSubtext = () =>
  useAssignSetting(FE_BATCH_9_SIGN_UP_MODAL_SUBTEXT_250417);
